import { Component, HostListener, OnInit } from "@angular/core";
import { SiAuthenticationService } from "@strategic-insights/ng-authentication";
import { Router } from "@angular/router";
import { CookieService } from "ngx-cookie";
declare let $;

@Component({
  selector: "si-app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  constructor(
    private siAuthenticationService: SiAuthenticationService,
    private router: Router,
    private cookieService: CookieService
  ) {}

  ngOnInit() {
    if (sessionStorage.getItem('standaloneRoute')) { return; }

    const hasToken = this.siAuthenticationService.getWebToken() ||
                     this.siAuthenticationService.getAuthToken();

    if (hasToken) {
      let activeCustomer = this.siAuthenticationService.getActiveCustomer();

      if (!activeCustomer) {
        activeCustomer = this.cookieService.get('activeCustomer') ||
                        this.cookieService.get('orgname') ||
                        localStorage.getItem('activeCustomer') ||
                        sessionStorage.getItem('activeCustomer');

        if (activeCustomer) {
          this.siAuthenticationService.setActiveCustomer(activeCustomer);

          if (this.router.url.includes('customerAccess')) {
            this.router.navigate([
              this.siAuthenticationService.getUnformattedCustomerName(activeCustomer)
            ]);
          }
        }
      } else {
        if (this.router.url.includes('customerAccess')) {
          this.router.navigate([
            this.siAuthenticationService.getUnformattedCustomerName(activeCustomer)
          ]);
        }
      }
    }
  }

  /**
   * Handling Browser's Back/forward button functionality
   */
  @HostListener("window:popstate", ["$event"])
  onPopState(event) {
    if (event.state != null) {
      alert(`Currently Browser's back/forward button support is not available
Redirecting to the same page !`);
      this.redirectToSamePage();
    }
  }
  redirectToSamePage() {
    history.go(0);
  }
  /**
   * Clears cache
   */
  clearCache() {
    window.location.reload();
  }
}
